import React from 'react';
import { Target, DollarSign, Award, Sparkles } from 'lucide-react';
import { formatValue } from '../crmConstants';

const cardStyle = {
  padding: '1rem 1.25rem', background: '#fff', borderRadius: 8, border: '1px solid #E5E7EB',
};

const labelRowStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem',
};

const valueStyle = {
  fontFamily: 'var(--font-heading)', fontSize: '1.5rem', fontWeight: 700, color: 'var(--navy)',
};

export const StatsCards = ({ stats, userRole }) => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', marginBottom: '1.25rem' }}>
    <div style={cardStyle} data-testid="stat-total-deals">
      <div style={labelRowStyle}>
        <span style={{ fontSize: '0.75rem', color: '#6B7280' }}>Total Deals</span>
        <Target size={16} style={{ color: '#3B82F6' }} />
      </div>
      <div style={valueStyle}>{stats.total_deals}</div>
    </div>
    <div style={cardStyle} data-testid="stat-pipeline-value">
      <div style={labelRowStyle}>
        <span style={{ fontSize: '0.75rem', color: '#6B7280' }}>Pipeline Value</span>
        <DollarSign size={16} style={{ color: '#F59E0B' }} />
      </div>
      <div style={valueStyle}>{formatValue(stats.total_value)}</div>
    </div>
    <div style={cardStyle} data-testid="stat-won-value">
      <div style={labelRowStyle}>
        <span style={{ fontSize: '0.75rem', color: '#6B7280' }}>Won Value</span>
        <Award size={16} style={{ color: '#10B981' }} />
      </div>
      <div style={{ ...valueStyle, color: '#10B981' }}>{formatValue(stats.won_value)}</div>
    </div>
    {/* Commission card - Admin only */}
    {userRole === 'admin' && stats.total_commission !== undefined && (
      <div style={cardStyle} data-testid="stat-commission">
        <div style={labelRowStyle}>
          <span style={{ fontSize: '0.75rem', color: '#6B7280' }}>Company Commission</span>
          <Sparkles size={16} style={{ color: '#8B5CF6' }} />
        </div>
        <div style={{ ...valueStyle, color: '#8B5CF6' }}>{formatValue(stats.total_commission)}</div>
        {stats.total_sales_rep_commission !== undefined && (
          <div style={{ fontSize: '0.7rem', color: '#9CA3AF', marginTop: '0.25rem' }}>
            Rep payout: {formatValue(stats.total_sales_rep_commission)}
          </div>
        )}
      </div>
    )}
    <div style={{
      padding: '1rem 1.25rem', background: 'linear-gradient(135deg, #059669 0%, #0D9488 100%)',
      borderRadius: 8, color: '#fff',
    }} data-testid="stat-win-rate">
      <div style={{ fontSize: '0.7rem', fontWeight: 500, opacity: 0.8, marginBottom: '0.375rem' }}>WIN RATE</div>
      <div style={{ fontFamily: 'var(--font-heading)', fontSize: '1.5rem', fontWeight: 700 }}>
        {stats.total_deals > 0
          ? `${Math.round(((stats.pipeline?.['Closed Won'] || 0) / stats.total_deals) * 100)}%`
          : '0%'
        }
      </div>
    </div>
  </div>
);
